import { makeStyles } from '@futrli/ui-components';
import { textEditorFontSizeOptions } from '../text-card/text-card';

export const textPanelStyles = makeStyles({
  root: {
    'marginTop': 20,
    '& .toolbar.ql-toolbar': {
      'border': 'none',
      'padding': 0,
      '& .row': {
        'display': 'flex',
        'justify-content': 'space-between',
        'margin-bottom': 20,
        '& .half': {
          'width': 'calc(50% - 8px)',
          '& .ql-picker': {
            width: '100%'
          }
        },
        '& .big': {
          'width': 232,
          '& .ql-picker': {
            width: '100%'
          }
        }
      },
      '& label': {
        'font-family': 'SageUI',
        'font-style': 'normal',
        'font-weight': 400,
        'font-size': 16,
        'line-height': 1.6,
        'color': 'rgba(0, 0, 0, 0.9)',
        'display': 'block',
        'margin-bottom': 8
      },
      '& .ql-picker': {
        'border': '1px solid #668494',
        'border-radius': 4,
        'padding': '10px 2px',
        'height': 48,
        'box-sizing': 'border-box'
      },
      '& .ql-picker.ql-expanded .ql-picker-label': {
        border: 'none'
      },
      '& .ql-picker.ql-size.ql-expanded .ql-picker-options': {
        'max-height': 300,
        'overflow': 'auto'
      },
      '& button, & .ql-picker.ql-color-picker': {
        'border': '1px solid #668494',
        'border-radius': 4,
        'width': 48,
        'height': 48,
        'padding': 12,
        '& .ql-transparent': {
          opacity: 1
        }
      },
      '& .ql-picker.ql-color-picker .ql-picker-label': {
        padding: 0,
        border: 'none'
      },
      '& .ql-picker.ql-color-picker.ql-expanded .ql-picker-options': {
        right: -15
      }
    },
    // custom properties styling
    '& .ql-picker.ql-font': {
      '& .ql-picker-item': {
        'font-size': 0,
        '&:before': {
          'content': 'attr(data-value) !important',
          'font-size': '14px'
        }
      },
      '& .ql-active': {
        '&:before': {
          'content': 'attr(data-value) !important',
          'font-size': '14px'
        }
      }
    },

    '& .ql-picker.ql-font .ql-picker-label[data-value="Arial"]::before, & .ql-picker.ql-font .ql-picker-item[data-value="Arial"]::before': {
      'font-family': 'Arial',
      'content': '"Arial" !important'
    },
    '& .ql-picker.ql-font .ql-picker-label[data-value="SageUI"]::before, & .ql-picker.ql-font .ql-picker-item[data-value="SageUI"]::before': {
      'font-family': 'SageUI',
      'content': '"SageUI" !important'
    },
    '& .ql-picker.ql-font .ql-picker-label[data-value="times-new-roman"]::before, & .ql-picker.ql-font .ql-picker-item[data-value="times-new-roman"]::before': {
      'font-family': '"Times New Roman"',
      'content': '"Times New Roman" !important'
    },

    /* Set content font-families */
    '& .ql-font-Arial': {
      'font-family': 'Arial'
    },
    '& .ql-font-SageUI': {
      'font-family': 'SageUI'
    },
    '& .ql-font-times-new-roman': {
      'font-family': '"Times New Roman"'
    },

    ...textEditorFontSizeOptions.reduce((acc, e) => {
      acc[
        `& .ql-picker.ql-size .ql-picker-label[data-value="${e}"]::before, & .ql-picker.ql-size .ql-picker-item[data-value="${e}"]::before`
      ] = {
        'content': `"${e}"`,
        'font-size': `${e} !important`
      };
      return acc;
    }, {} as Record<string, Record<string, string>>)
  }
});
